Ext.define('SA.view.ComparisonToolbar', {
    extend: 'SA.view.Toolbar',

    items: [
        {
            xtype: 'pvt-fill'
        }, {
            xtype: 'pvt-filtering-button',
            itemId: 'filteringButton',
            margin: '0 10 0 0'
        }, {
            xtype: 'pvt-view-actions-button',
            itemId: 'viewActionsButton',
            margin: '0 10 0 0'
        }, {
            xtype: 'pvt-export-button',
            margin: '0 10 0 0'
        }
    ],

    initComponent() {
        this.callParent();

        this.filteringButton = this.down('#filteringButton');
        this.viewActionsButton = this.down('#viewActionsButton');

        this.filteringButton.setMenuCfg({xtype: 'filters-window', projectView: this.model});

        this.viewActionsButton
            .setProjectView(this.model)
            .addEditItem()
            .addGroup([
                {xtype: 'menu-hide-country'},
                {text: 'Transpose Report', handler: () => this.onClickTranspose()}
            ])
            .addDeleteItem();
    },

    onClickTranspose() {
        this.fireEvent('click:transpose');
    },

    setFilteringButtonIndicatorVisible(visible) {
        this.filteringButton.setIndicatorVisible(visible);
    }
});